import Vue from 'vue'
import Vuex from 'vuex'

import { getPlugins } from './plugins'

import { getModules } from './store-modules'

Vue.use(Vuex)

////////////////
//////////////////////////
//////////////////////////////////////////
//////////

export const getStore = appConfig => {
  const store = new Vuex.Store({
    state: {},
    mutations: {},
    actions: {},
    modules: getModules(appConfig),
    plugins: getPlugins(),
  })

  return store
}
